import { get, api, getBranchOwner } from '@config';

const branch = getBranchOwner();

export function loadNcm(ncm, set) {

    let url = `${api.products.ncm}?branch_owner=${branch.id}&code=${ncm}`;
    if (isNaN(ncm)) {
        url = `${api.products.ncm}${ncm}/?branch_owner=${branch.id}`;
    }
    const payload = data => {
        let code, description, id;
        if (isNaN(ncm)) {
            id = data.id
            code = data.code;
            description = data.description;
        } else {
            id = data[0].id
            code = data[0].code;
            description = data[0].description;
        } 

        set({ value: id, code, label: description }) 
    };

    get(url, payload);
}

export function loadCest(cest, set) {
    cest = cest[0] === "0" ? cest.substr(1, cest.length) : cest;

    let url = `${api.products.cest}?branch_owner=${branch.id}&code=${cest}`;
    if (isNaN(cest)) {
        url = `${api.products.cest}${cest}/?branch_owner=${branch.id}`;
    }
    const payload = data => {
        let code, description, id;
        if (isNaN(cest)) {
            id = data.id
            code = data.code;
            description = data.description;
        } else {
            id = data[0].id
            code = data[0].code;
            description = data[0].description;
        } 
        
        set({ value: id, code, label: description })  
    };

    get(url, payload);
}


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/loadTaxes.js